// Проверяет что User-Agent соответствует IE 9/10/11 или Edge
export function isIeOrEdge(userAgent?: string) {
  return !!userAgent && /MSIE|rv:11|Edge/i.test(userAgent);
}
